import { action, makeObservable, observable } from "mobx";

import { RootStore } from ".";
import { CheckTicketType } from "../enums/check-ticket-type";
import { JackpotModal, JackpotDetails } from "../models/modal";
import {BalanceTransactionRequest, BalanceTransactionRequestModal} from "../models";

interface CheckModal {
  data: string;
  open: boolean;
  type?: CheckTicketType;
}

interface HotKeysModal {
  open: boolean;
}

export class ModalStore {
  private rootStore?: RootStore;

  public checkModal: CheckModal = {
    open: false,
    data: "",
    type: CheckTicketType.betTicket,
  };

  public jackpotModal: JackpotModal = {
    open: false,
    data: {} as JackpotDetails,
  };

  public balanceRequestModal: BalanceTransactionRequestModal = {
    open: false,
    data: {} as BalanceTransactionRequest,
  };

  public returnModalOpen = false;

  public isOpenBalanceAndLimitModal: boolean = false;

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      isOpenBalanceAndLimitModal: observable,
      returnModalOpen: observable,
      checkModal: observable,
      jackpotModal: observable,
      balanceRequestModal: observable,
      setCheckModal: action.bound,
      setJackpotModal: action.bound,
      setReturnModalOpen: action.bound,
      setIsOpenBalanceAndLimitModal: action.bound,
      setBalanceRequestModal: action.bound,
    });
  }

  public setIsOpenBalanceAndLimitModal(bool: boolean): void {
    this.isOpenBalanceAndLimitModal = bool;
  }

  public setCheckModal(value: CheckModal): void {
    this.checkModal = value;
  }

  public setJackpotModal(value: JackpotModal): void {
    this.jackpotModal = value;
  }

  public setReturnModalOpen(value: boolean): void {
    this.returnModalOpen = value;
  }

  public setBalanceRequestModal(value: BalanceTransactionRequestModal): void {
    this.balanceRequestModal = value;
  }

}
